/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`En Vue debemos crear la función que hace una petición una API dentro de los métodos y después debe ser llamada dentro de la función `}<inlineCode parentName="p">{`created`}</inlineCode>{` para que se ejecute cuando se creé o se monte el componente.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-html"
      }}><code parentName="pre" {...{
          "className": "language-html"
        }}><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`script`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token script"
          }}><span parentName="span" {...{
              "className": "token language-javascript"
            }}>{`
`}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`import`}</span>{` `}<span parentName="span" {...{
                "className": "token imports"
              }}><span parentName="span" {...{
                  "className": "token maybe-class-name"
                }}>{`PokedexScreen`}</span></span>{` `}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`from`}</span>{` `}<span parentName="span" {...{
                "className": "token string"
              }}>{`'./PokedexScreen.vue'`}</span>{`
`}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`import`}</span>{` `}<span parentName="span" {...{
                "className": "token imports"
              }}><span parentName="span" {...{
                  "className": "token maybe-class-name"
                }}>{`PokedexForm`}</span></span>{` `}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`from`}</span>{` `}<span parentName="span" {...{
                "className": "token string"
              }}>{`'./PokedexForm.vue'`}</span>{`

`}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`export`}</span>{` `}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`default`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
  `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`name`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token string"
              }}>{`'Pokedex'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`
  `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`components`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
    `}<span parentName="span" {...{
                "className": "token maybe-class-name"
              }}>{`PokedexScreen`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`
    `}<span parentName="span" {...{
                "className": "token maybe-class-name"
              }}>{`PokedexForm`}</span>{`
  `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`

  `}<span parentName="span" {...{
                "className": "token function"
              }}>{`data`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
    `}<span parentName="span" {...{
                "className": "token keyword control-flow"
              }}>{`return`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
      `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`error`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token boolean"
              }}>{`false`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`
      `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`loading`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token boolean"
              }}>{`true`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`
      `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`pokemon`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token keyword null nil"
              }}>{`null`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`
      `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`pokemonId`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token known-class-name class-name"
              }}>{`Math`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token method function property-access"
              }}>{`floor`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token known-class-name class-name"
              }}>{`Math`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token method function property-access"
              }}>{`random`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`*`}</span>{` `}<span parentName="span" {...{
                "className": "token number"
              }}>{`806`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`+`}</span>{` `}<span parentName="span" {...{
                "className": "token number"
              }}>{`1`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token method function property-access"
              }}>{`toString`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{`
    `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span>{`
  `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`

  `}<span parentName="span" {...{
                "className": "token function"
              }}>{`created`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
    `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token method function property-access"
              }}>{`getPokemon`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{`
  `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`

  `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`methods`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
    `}<span parentName="span" {...{
                "className": "token comment"
              }}>{`// Mientras se llama a la API, loading es verdadero,`}</span>{`
    `}<span parentName="span" {...{
                "className": "token comment"
              }}>{`// cuando la API nos da una respuesta, el estado se actualiza`}</span>{`
    `}<span parentName="span" {...{
                "className": "token comment"
              }}>{`// dependiendo de si todo fue un éxito o un fracaso`}</span>{`
    `}<span parentName="span" {...{
                "className": "token function"
              }}>{`getPokemon`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
      `}<span parentName="span" {...{
                "className": "token function"
              }}>{`fetch`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token template-string"
              }}><span parentName="span" {...{
                  "className": "token template-punctuation string"
                }}>{`\``}</span><span parentName="span" {...{
                  "className": "token string"
                }}>{`https://pokeapi.co/api/v2/pokemon/`}</span><span parentName="span" {...{
                  "className": "token interpolation"
                }}><span parentName="span" {...{
                    "className": "token interpolation-punctuation punctuation"
                  }}>{`\${`}</span><span parentName="span" {...{
                    "className": "token keyword"
                  }}>{`this`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`.`}</span><span parentName="span" {...{
                    "className": "token property-access"
                  }}>{`pokemonId`}</span><span parentName="span" {...{
                    "className": "token interpolation-punctuation punctuation"
                  }}>{`}`}</span></span><span parentName="span" {...{
                  "className": "token template-punctuation string"
                }}>{`\``}</span></span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{`
        `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token method function property-access"
              }}>{`then`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token parameter"
              }}>{`res`}</span>{` `}<span parentName="span" {...{
                "className": "token arrow operator"
              }}>{`=>`}</span>{` res`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token method function property-access"
              }}>{`json`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{`
        `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token method function property-access"
              }}>{`then`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token parameter"
              }}>{`data`}</span>{` `}<span parentName="span" {...{
                "className": "token arrow operator"
              }}>{`=>`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
          `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token property-access"
              }}>{`pokemon`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` data
          `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token property-access"
              }}>{`loading`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` `}<span parentName="span" {...{
                "className": "token boolean"
              }}>{`false`}</span>{`
        `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{`
        `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token keyword control-flow"
              }}>{`catch`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token parameter"
              }}>{`err`}</span>{` `}<span parentName="span" {...{
                "className": "token arrow operator"
              }}>{`=>`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
          `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token property-access"
              }}>{`loading`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` `}<span parentName="span" {...{
                "className": "token boolean"
              }}>{`false`}</span>{`
          `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`this`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token property-access"
              }}>{`error`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span>{` `}<span parentName="span" {...{
                "className": "token boolean"
              }}>{`true`}</span>{`
        `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{`
    `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`
  `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span>{`
`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span>{`
`}</span></span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`script`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
`}</code></pre></div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;